import React from 'react';
import { Button, Message } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import './index.less';
import cloneDeep from 'lodash/cloneDeep';
import type { Editor } from '@meitu/saas-editor-core';
import type { EventEmitter } from '@meitu/saas-editor-core/es/framework';
import {
    CanvasType,
    IExtraInfo,
    ILayerProps,
    MAX_STAGES,
    MAX_STAGES_TIP,
    PosterType,
} from '@meitu/saas-editor-core/es/version-types';
import { useLocaleStore } from '@/i18n';
import { checkTypeIsAiPPT, checkTypeIsPPT } from '@/utils/stage';
import { CreateAiPPT } from '../create-ai-ppt';
import { useMultiSelect } from '../multi-select-provider';

type CreateStageBtnProps = {
    editor: Editor;
    events: EventEmitter;
    recordId: string;
    setIsAiCreate: (isAiCreate: boolean) => void;
    setAiRegen: (data: { isAiRegen: boolean; regenIndex?: number }) => void;
    isAiCreate: boolean;
    canvasType: CanvasType;
    posterType: PosterType;
    initPPT: (stageIndex?: number) => void;
    getCurrentScene: () => string;
    isFromHuaweiCustom: () => boolean;
    transferIdParams: any;
    isFullscreen: boolean;
    templateSubject: string;
    showCreateTip: (tip: string) => void;
    hideCreateTip: () => void;
    transferTemplateToClient: (templateDetail: any, fontList: any) => Promise<any>;
    // import { packageTemplateConf } from '@/hooks/useFetchTemplate';
    packageTemplateConf: (
        templateConf: any,
        extraInfo: IExtraInfo,
        init: boolean,
    ) => {
        stages: ILayerProps[][];
        extraInfos: IExtraInfo[];
    };
    // import { fetchPPTApplyItem } from '@/services';
    fetchPPTApplyItem: (params: any) => Promise<any>;
    // import { fetchPPTCheckItemProcess } from '@/services';
    fetchPPTCheckItemProcess: (params: any) => Promise<any>;
    // import { fetchPPTItemDetail } from '@/services';
    fetchPPTItemDetail: (params: any) => Promise<any>;
    stageExtraInfo?: { [key: string]: any };
};
export const CreateStageBtn: React.FC<CreateStageBtnProps> = React.memo(
    ({
        recordId,
        setIsAiCreate,
        setAiRegen,
        isAiCreate,
        canvasType,
        posterType,
        editor,
        events,
        initPPT,
        getCurrentScene,
        isFromHuaweiCustom,
        transferIdParams,
        isFullscreen,
        templateSubject,
        showCreateTip,
        hideCreateTip,
        transferTemplateToClient,
        packageTemplateConf,
        fetchPPTApplyItem,
        fetchPPTCheckItemProcess,
        fetchPPTItemDetail,
        stageExtraInfo,
    }) => {
        const { $t } = useLocaleStore();
        const isAiPPT = checkTypeIsAiPPT(posterType);
        const isPPT = checkTypeIsPPT(canvasType) || isAiPPT;
        const activeIndex = editor.active.getActiveStageIndex();
        const { handleAfterCopyOrDel } = useMultiSelect();

        return (
            <div className="c-navigation-collapse__btn-wrap">
                <Button
                    className="c-navigation-collapse__btn"
                    icon={<IconFont name="PlusCircleBold" fontSize={14} />}
                    onClick={() => {
                        const index = editor.stage.count();
                        if (index < MAX_STAGES) {
                            if (isPPT) {
                                const stage = editor.stage.getStageByIndex(activeIndex);
                                editor.stage.create(
                                    activeIndex,
                                    undefined,
                                    cloneDeep(stage[0]),
                                    stageExtraInfo?.masterPage?.layers,
                                );
                            } else {
                                editor.stage.create(activeIndex, undefined);
                            }
                            handleAfterCopyOrDel();
                            window._stat_track('hb_edit_navigation_click', {
                                class: 'add_page',
                            });
                            window._stat_track('tpbj_subfunction_click', {
                                func: '19_95',
                            });
                            window._stat_track('tpbj_subfunction_tick', {
                                func: '19_95',
                            });
                        } else {
                            Message.warning(MAX_STAGES_TIP());
                        }
                    }}
                >
                    {$t((v) => v.collapse.navigationCollapse.createPage)}
                </Button>
                <CreateAiPPT
                    transferTemplateToClient={transferTemplateToClient}
                    packageTemplateConf={packageTemplateConf}
                    fetchPPTApplyItem={fetchPPTApplyItem}
                    fetchPPTCheckItemProcess={fetchPPTCheckItemProcess}
                    fetchPPTItemDetail={fetchPPTItemDetail}
                    editor={editor}
                    events={events}
                    getCurrentScene={getCurrentScene}
                    isFromHuaweiCustom={isFromHuaweiCustom}
                    transferIdParams={transferIdParams}
                    isFullscreen={isFullscreen}
                    templateSubject={templateSubject}
                    showCreateTip={showCreateTip}
                    hideCreateTip={hideCreateTip}
                    isAiPPT={isAiPPT}
                    initPPT={initPPT}
                    recordId={recordId}
                    setIsAiCreate={setIsAiCreate}
                    setAiRegen={setAiRegen}
                    isAiCreate={isAiCreate}
                />
            </div>
        );
    },
);
